import { createFileRoute } from '@tanstack/react-router'
import { RelationTypesPage } from '../../../components/relation-types/RelationTypesPage'

export const Route = createFileRoute('/$org/relation-types/')({
    component: RelationTypesPage,
})
